var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextAlignCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_text_align_center_24_filled",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,17 C17.5523,17 18,17.4477 18,18 C18,18.5523 17.5523,19 17,19 L7,19 C6.44772,19 6,18.5523 6,18 C6,17.4477 6.44772,17 7,17 L17,17 Z M21,11 C21.5523,11 22,11.4477 22,12 C22,12.51285 21.613973,12.9355092 21.1166239,12.9932725 L21,13 L3,13 C2.44772,13 2,12.5523 2,12 C2,11.48715 2.38604429,11.0644908 2.88337975,11.0067275 L3,11 L21,11 Z M19,5 C19.5523,5 20,5.44772 20,6 C20,6.55228 19.5523,7 19,7 L5,7 C4.44772,7 4,6.55228 4,6 C4,5.44772 4.44772,5 5,5 L19,5 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignCenter);
export default __webpack_public_path__ + "static/media/text-align-center.fdccdb3b802289fb1f2f8800261bf890.svg";
export { ForwardRef as ReactComponent };